// Shared by the page wrapper and dock so hidden navigation leaves no spacer.
export const isAuctionOrSeasonRoute = (pathname) =>
  /^\/(?:auctions|auction|seasons)(?:\/|$)/.test(pathname);
